<template>
  <div class="content">
    <div class="content">
      <div class="md-layout">
        <div
            class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
        >
          <p-s-table
                  tableHeaderColor="purple"
                  title="Ausschreibungen"
                  subTitle="Dieses Tool ermöglicht Ihnen Preisausschreibungen zu erstellen, die Lieferanten mit Angeboten beantworten können."
                  showFilter="true"
                  sortBy="date"
                  v-bind:actions="actions"
                  v-bind:data="this.tenders"
                  v-bind:dict="this.tendersDict"
          ></p-s-table>
        </div>
        <router-link to="/app/tenders/new" tag="md-button" class="md-primary" style="margin-left: auto; margin-right: 20px;">Neu anlegen</router-link>
      </div>
    </div>
  </div>
</template>


<script>
  import { PSTable } from "@/components";
  import store from '@/store/index.js';
  import api from "@/api/api";

export default {
  name: "PriceBenchmark",
  components: {
    PSTable
  },
  data() {
    return {
      tenders: [],
      tendersDict: [
        { key: 'date', label: 'Datum', type: 'dateTime'},
        { key: 'numberofproducts', label: 'Anzahl an Artikeln', type: 'number'},
        { key: 'state', label: 'Status', type: 'string'},
      ],
      actions: [
        {
          action: this.openTenderDetails,
          icon: "search"
        }
      ]
    }
  },
  created () {
    store.commit("setLoading", true);

    api.getTenders().then((result) => {
      this.tenders = result.data;

      this.tenders.forEach((item) => {
        if (item.state === 0) {  //TO-DO: Translate to string "abgeschlossen" or "in Bearbeitung" (1/0)
          item.state = "in Bearbeitung";
        } else if (item.state > 0) {
          item.state = "abgeschlossen";
        }
      });

      store.commit("setLoading", false);
    });
  },
  methods: {
    openTenderDetails(item) {
      const id = item.id;
      let routeData = this.$router.resolve({ name: 'Preisausschreibung Details', params: { id } });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

